<div class="background">
    <div class="top-separator"></div>
    <div class="ui two column stackable grid">
        <div class="column button-column">
            <div class="border-right">
                <button (click)="goToGarage()" class="ui secondary button centered">Garage</button>
                <div *ngIf="!isSmartphone">
                    <div class="ui middle aligned grid">
                        <div class="five wide column"></div>
                        <div class="icon-container one wide column no-padding">
                            <img class="icon" src="../../../../assets/img/marker.png"/>
                        </div>
                        <div class="icon-text ten wide column">
                            <p class="margin-bottom-0 icon-text">2, Route de Wiltz L - 9643 Büderscheid-Wiltz</p>
                        </div>
                    </div>
                    <div class="ui middle aligned grid">
                        <div class="five wide column"></div>
                        <div class="icon-container one wide column no-padding">
                            <img class="icon" src="../../../../assets/img/mail.png"/>
                        </div>
                        <div class="icon-text ten wide column ">
                            <a href="mailto:garage@schiltz-buderscheid.lu" class="margin-bottom-0 icon-text">garage@schiltz-buderscheid.lu</a>
                        </div>
                    </div>
                    <div class="ui middle aligned grid">
                        <div class="five wide column"></div>
                        <div class="icon-container one wide column no-padding">
                            <img class="icon" src="../../../../assets/img/welcome/phoneWhite.png"/>
                        </div>
                        <div class="icon-text ten wide column ">
                            <p class="margin-bottom-0 icon-text">Phone: +352 26 88 90 75</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="column">
            <button (click)="goToTrips()" class="ui secondary button centered">Voyage</button>
            <div *ngIf="!isSmartphone">
                <div class="ui middle aligned grid">
                    <div class="five wide column"></div>
                    <div class="icon-container one wide column no-padding">
                        <img class="icon" src="../../../../assets/img/marker.png"/>
                    </div>
                    <div class="icon-text ten wide column ">
                        <p class="margin-bottom-0 icon-text">2, Route de Wiltz L - 9643 Büderscheid-Wiltz</p>
                    </div>
                </div>
                <div class="ui middle aligned grid">
                    <div class="five wide column"></div>
                    <div class="icon-container one wide column no-padding">
                        <img class="icon" src="../../../../assets/img/mail.png"/>
                    </div>
                    <div class="icon-text ten wide column ">
                        <a href="mailto:voyages@schiltz-buderscheid.lu" class="margin-bottom-0 icon-text">voyages@schiltz-buderscheid.lu</a>
                    </div>
                </div>
                <div class="ui middle aligned grid">
                    <div class="five wide column"></div>
                    <div class="icon-container one wide column no-padding">
                        <img class="icon" src="../../../../assets/img/welcome/phoneWhite.png"/>
                    </div>
                    <div class="icon-text ten wide column ">
                        <p class="margin-bottom-0 icon-text">Phone: +352 26 88 97 88</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <info-popup></info-popup>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/welcome/welcome.html